"use client";

import type { ImageProps } from "next/image";
import { getImageProps } from "next/image";

import type { FindStoreBannerProps as UiFindStoreBannerProps } from "@jti/ui/eva-components/Footer/components/FindStoreBanner";
import { FindStoreBanner as UiFindStoreBanner } from "@jti/ui/eva-components/Footer/components/FindStoreBanner";
import { breakpoints } from "@jti/ui/hooks/useCurrentBreakpoint/useCurrentBreakpoint";

import type { FindStoreBannerProps } from "./inputs.builder";

export function FindStoreBanner(props: FindStoreBannerProps) {
  const { image, link, text } = props;
  const { title, alt, largeSrc, mediumSrc, smallSrc } = image || {};

  return (
    <UiFindStoreBanner
      renderImage={Image}
      image={{
        title: title ?? "",
        alt: alt ?? "",
        largeSrc: largeSrc ?? "",
        mediumSrc: mediumSrc ?? "",
        smallSrc: smallSrc ?? "",
      }}
      link={link ?? ""}
      text={text ?? ""}
    />
  );
}

function Image(props: RenderImageProps) {
  const { alt, largeSrc, mediumSrc, smallSrc } = props;

  const common: Partial<ImageProps> = {
    priority: false,
    width: 680,
    sizes: "100vw",
    style: { width: "100%" },
  };

  const {
    props: { srcSet: desktop, ...rest },
  } = getImageProps({
    ...common,
    src: largeSrc || "",
    height: 500,
    alt: alt || "",
  });
  const {
    props: { srcSet: medium },
  } = getImageProps({
    ...common,
    height: 380,
    src: mediumSrc || "",
    alt: alt || "",
  });
  const {
    props: { srcSet: small },
  } = getImageProps({
    ...common,
    height: 500,
    src: smallSrc || "",
    alt: alt || "",
  });

  return (
    <picture>
      <source media={breakpoints.lg} srcSet={desktop} />
      {mediumSrc ? <source media={breakpoints.md} srcSet={medium} /> : null}
      {smallSrc ? <source media={breakpoints.sm} srcSet={small} /> : null}
      {/* Alt prop is already provided by rest props */}
      <img {...rest} />
    </picture>
  );
}

type RenderImageProps = Parameters<NonNullable<UiFindStoreBannerProps["renderImage"]>>[0];
